import QuestionObj from './Models/QuestionObj';

export function addRolesToQuestionSet(QuestionSets, roles, questionAndAnswerSets){
    for(let {English} of roles){
        const englishRole = English;    
        QuestionSets[englishRole] = createQuestionSetFromSchema(questionAndAnswerSets, englishRole);
    }
    
}

export function createQuestionSetFromSchema (questionAndAnswerSets, role){
    // console.log(questionAndAnswerSets, role);

    return questionAndAnswerSets[role].map(qObj => {
        const { 
            NegCopy: negCopy,
            NegLink: negLink,
            LinkText: negLinkText,  
        } = qObj;

        
        return new QuestionObj({
            ...qObj,
            negCopy,
            negLink,
            negLinkText
        })
    });
}

export const fixedEls = {
    getStarted: {
        English: 'Get started',
        German: 'Loslegen',
        Espanol: 'Empezar',
        French: 'Lancez-vous',
        Italian: 'Inizia',
        Russian: 'Начать',
        Turkish: 'Başla',
        Portuguese: "Comece já",
        SpanishLAD: "Introducción",
    },
    restartBtn: {
        English: "Restart",
        German: 'Neustarten',
        Espanol: "Reiniciar",
        French: "Recommencer",
        Italian: "Ricomincia",
        Russian: "Начать сначала",
        Turkish: "Tekrar Başlat",
        Portuguese: "Reiniciar",
        SpanishLAD: "Reiniciar",
    },
    nextBtn: {
        English: "Next",
        German: 'Weiter',
        Espanol: "Siguiente",
        French: "Suivant",
        Italian: "Avanti",
        Russian: "Далее",
        Turkish: "Sonraki",
        Portuguese: "Avançar",
        SpanishLAD: "Siguiente",
    },
    finishBtn: {
        English: "Finish",
        German: 'Beenden',
        Espanol: "Finalizar",
        French: "Terminer",
        Russian: "Завершить",
        Turkish: "Bitir",
        Italian: "Termina",
        Portuguese: "Concluir",
        SpanishLAD: "Finalizar",        
    }
}